import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  mutation AcceptRenewalQuote(
    $businessId: ID!
    $option: InputRenewalOption!
    $etag: String!
    $signatureContact: InputRenewalContact!
    $seats: Int
    $productsUpdated: [InputRenewalProduct]
    $productsRemoved: [InputRenewalProduct]
    $productsAdded: [InputRenewalProduct]
  ) {
    acceptRenewalQuote(
      businessId: $businessId
      option: $option
      etag: $etag
      signatureContact: $signatureContact
      seats: $seats
      productsUpdated: $productsUpdated
      productsRemoved: $productsRemoved
      productsAdded: $productsAdded
    )
  }
`

export const acceptRenewalQuoteKey = getQueryNames(query)[0]

export default query
